import React, { useState } from 'react'
import { WebsiteHeaderInterface } from 'src/shared/types/website-entities'
import { Switcher } from '../../ui-lib/switcher'
import { WebsiteHeaderDesign } from './website-header-design'
import { WebsiteHeaderElements } from './website-header-elements'

export interface WebsiteHeaderSettingsProps {
  entity: WebsiteHeaderInterface
}

const sidebarModes = {
  elements: 'elements',
  design: 'design',
} as const
type SidebarMode = keyof typeof sidebarModes

export const WebsiteHeaderSettings = ({
  entity,
}: WebsiteHeaderSettingsProps) => {
  const [mode, setMode] = useState<SidebarMode>(sidebarModes.elements)

  return (
    <>
      <Switcher
        btnList={[
          {
            value: sidebarModes.elements,
            content: 'components.core.toolbox.types.elements',
          },
          {
            value: sidebarModes.design,
            content: 'components.core.toolbox.types.design',
          },
        ]}
        value={mode}
        update={setMode}
        wrapperClassName="p-0 mb-5"
      />

      {mode === sidebarModes.elements ? (
        <WebsiteHeaderElements entity={entity} />
      ) : (
        <WebsiteHeaderDesign entity={entity} />
      )}
    </>
  )
}
